export default __webpack_public_path__ + "static/media/dwarakaHistoryOne.16b04ebb.jpg";